<template>
    <Modal>
        <div slot="modal-container" class="creating-modal-container">
            <div class="modal-wrapper">

                <template v-if="loading">
                    Loading ...
                </template>

                <div v-else class="modal-container creating-modal edit-property">
                    <div class="close" v-on:click="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="11.891" height="11.891"
                             viewBox="0 0 23.781 23.781">
                            <path class="fill-grey"
                                  d="M382.829,147l8.485,8.485a2,2,0,0,1-2.829,2.829L380,149.829l-8.485,8.485a2,2,0,0,1-2.829-2.829L377.172,147l-8.486-8.485a2,2,0,0,1,2.829-2.829L380,144.172l8.485-8.486a2,2,0,0,1,2.829,2.829Z"
                                  transform="translate(-368.125 -135.125)"/>
                        </svg>
                    </div>
                    <h2>{{ $t('property-edit.modal.headline') }}</h2>

                    <div class="inputs">
                        <div class="row">
                            <div class="input-container zipcode">
                                <p class="subject">{{ $t('property.create.info.zipcode') }}</p>
                                <input
                                    min="1000"
                                    max="9999"
                                    id="zipcode"
                                    type="number"
                                    v-model="zipcode"
                                    name="zipcode"
                                    autofocus
                                    autocomplete="off"
                                    autofill="false"
                                >
                            </div>
                            <div class="input-container">
                                <p class="subject">{{ $t('property.create.info.city') }}</p>
                                <input
                                    id="city"
                                    type="text"
                                    v-model="city"
                                    name="city"
                                    disabled
                                    :placeholder="$t('property.create.info.city')">
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-container">
                                <validation-provider rules="required" v-slot="{failed}" slim>
                                    <input
                                        id="address"
                                        autocomplete="off"
                                        type="text"
                                        v-model="address"
                                        class="form-control"
                                        name="address"
                                        :disabled="!city.length"
                                        :placeholder="$t('property.create.info.address')"
                                        :class="{fill: city, 'has-error': failed}"
                                    />
                                </validation-provider>
                                <div class="auto-complete" v-if="showAutocomplete" transition="fade">
                                    <ul>
                                        <li v-for='address in autocompleteValues' @click='setAddressValue(address)'>
                                            {{ address.forslagstekst }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="warning">
                            <span v-if="showZipWarning">
                                {{ $t('property.create.info.zipcode-fail') }}
                            </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-container">
                                <p class="subject">{{ $t('property-edit.label.owner') }}</p>
                                <div class="select-container">
                                    <select v-model="client_id" :disabled="saving || loading">
                                        <option value="">-</option>
                                        <option v-for="client in clients" :value="client.id">{{ client.name }}</option>
                                    </select>
                                    <div class="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="7"
                                             viewBox="0 0 20 11.97">
                                            <path class="fill-purple"
                                                  d="M3260.4,2087.48l-7.88,7.95a2.067,2.067,0,0,1-1.54.59,2.045,2.045,0,0,1-1.53-.59l-7.88-7.95a2.046,2.046,0,0,1,0-2.88,2.022,2.022,0,0,1,2.86,0l6.55,6.61,6.56-6.61a2.022,2.022,0,0,1,2.86,0A2.046,2.046,0,0,1,3260.4,2087.48Z"
                                                  transform="translate(-3241 -2084.03)"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button :disabled="dawa === {} || saving || loading" class="button purple" v-on:click="saveProperty()">
                            {{ $t('property-edit.modal.save') }}
                        </button>
                    </div>

                    <!--                    <div class="inputs">-->
                    <!--                        <div class="row">-->
                    <!--                            <div class="input-container zipcode">-->
                    <!--                                <p class="subject">{{ $t('property.create.info.zipcode') }}</p>-->
                    <!--                                <input :disabled="loading || saving" type="text" v-model="zipcode" />-->
                    <!--                            </div>-->
                    <!--                            <div class="input-container">-->
                    <!--                                <p class="subject">{{ $t('property.create.info.city') }}</p>-->
                    <!--                                <input :disabled="loading || saving" type="text" v-model="city" />-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                        <p class="subject">{{ $t('property.create.info.address') }}</p>-->
                    <!--                        <input :disabled="loading || saving" type="text" v-model="address" />-->
                    <!--                        <p class="subject">{{ $t('property-edit.label.owner') }}</p>-->
                    <!--                        <div class="select-container">-->
                    <!--                            <select v-model="client_id" :disabled="saving || loading">-->
                    <!--                                <option value="">-</option>-->
                    <!--                                <option v-for="client in clients" :value="client.id">{{ client.name }}</option>-->
                    <!--                            </select>-->
                    <!--                            <div class="icon">-->
                    <!--                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="7" viewBox="0 0 20 11.97">-->
                    <!--                                    <path class="fill-purple" d="M3260.4,2087.48l-7.88,7.95a2.067,2.067,0,0,1-1.54.59,2.045,2.045,0,0,1-1.53-.59l-7.88-7.95a2.046,2.046,0,0,1,0-2.88,2.022,2.022,0,0,1,2.86,0l6.55,6.61,6.56-6.61a2.022,2.022,0,0,1,2.86,0A2.046,2.046,0,0,1,3260.4,2087.48Z" transform="translate(-3241 -2084.03)"/>-->
                    <!--                                </svg>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                    <div class="button-container">-->
                    <!--                        <button :disabled="saving || loading" class="button purple" v-on:click="saveProperty()">{{ $t('property-edit.modal.save') }}</button>-->
                    <!--                        &lt;!&ndash; <button :disabled="saving || loading" class="button delete" v-on:click="deleteProperty()">{{ $t('property-edit.modal.delete') }}</button> &ndash;&gt;-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>
    </Modal>
</template>

<script>
import Vue from 'vue';

import {mapGetters} from 'vuex';

export default {
    props: [
        'id',
    ],
    data: () => ({
        showEdit: false,
        loading: false,
        saving: false,
        zipcode: '',
        city: '',
        address: '',
        client_id: '',
        clients: [],
        showZipWarning: false,
        isCompany: '',
        dawa: {},
        autocompleteValues: [],
    }),
    computed: {
        ...mapGetters([
            'getToken',
            'getUserCompanies',

        ]),
        showAutocomplete() {
            return this.autocompleteValues.length > 1 ||
                (this.autocompleteValues.length > 0 && this.autocompleteValues[0].forslagstekst !== this.address);
        }
    },
    methods: {
        load() {
            axios({
                method: 'GET',
                url: window.config.apiUrl + 'api/property/' + this.id,
                cancelToken: window.AuthorizationCancelSource.token,
            }).then(response => {
                this.zipcode = response.data.zip_code;
                this.city = response.data.city;
                this.address = response.data.address;
                this.client_id = response.data.client_id;
            });
        },
        loadClients() {
            axios({
                method: 'GET',
                url: window.config.apiUrl + 'api/client',
                cancelToken: window.AuthorizationCancelSource.token,
            }).then(response => {
                this.clients = response.data;
            });
        },
        saveProperty() {
            Vue.api.patch('/property/' + this.id, {
                zip_code: this.zipcode,
                address: this.address,
                city: this.city,
                client_id: this.client_id,
                dawa: this.dawa
            }, {
                before: () => this.saving = true,
                always: () => this.saving = false,
                callback: () => this.saved(),
            });
        },
        saved() {
            this.close();
        },
        close() {
            this.$emit('close');
        },
        setAddressValue(address) {
            this.dawa = address;
            this.address = address.forslagstekst;
        },
    },
    created() {
        this.load();
        this.loadClients();
    },
    watch: {
        zipcode: function (val) {
            if (val.length < 4) {
                this.city = '';
                this.showZipWarning = false;
            }
            if (val.length > 4) {
                this.zipcode = val.slice(0, 4);
            }
            if (val.length === 4) {
                axios({
                    method: 'GET',
                    url: 'https://dawa.aws.dk/postnumre/' + this.zipcode,
                }).then(response => {
                    this.city = response.data.navn
                }).catch(e => {
                    this.showZipWarning = true
                });
            }
        },
        address: function (val) {
            if (this.city.length && val.length >= 3) {
                axios({
                    method: 'GET',
                    url: 'https://dawa.aws.dk/autocomplete?q=' + val + '&postnr=' + this.zipcode + '&fuzzy=true'
                }).then(response => {
                    this.autocompleteValues = [];
                    let self = this;
                    response.data.forEach(function (item) {
                        self.autocompleteValues.push(item);
                    })
                    if (this.autocompleteValues.length === 1 && this.autocompleteValues[0] === val) {
                        this.autocompleteValues = [];
                    }
                }).catch(e => {
                    this.showZipWarning = true
                });
            }
        }
    },
}
</script>
